import React, {useEffect} from 'react';

export default () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://platform.twitter.com/widgets.js";
    document.getElementsByClassName("twitter-tweet")[0].appendChild(script);
  }, []);
  
  return (
    <section className="psre-tiga">
      <div className="container pt-2">
        <table className="table-borderless w-100 mb-5">
          <tr>
            <td>
              <p className="mb-0" style={{fontSize: '14px', fontWeight: '600'}}>Sosial Media</p>
            </td>
            <td className="tb" style={{width: '80%'}}>
              <div style={{borderTop: '1px solid rgba(49, 49, 49, 0.12)', width: '100%'}}></div>
            </td>
          </tr>
        </table>
        <blockquote className="twitter-tweet" data-lang="en"><p lang="in" dir="ltr">Live - Seminar &amp; Bimtek &quot;Pemanfaatan dan Kekuatan Hukum Tanda Tangan Elektronik  <a href="https://twitter.com/hashtag/JatengGayeng?src=hash&amp;ref_src=twsrc%5Etfw">#JatengGayeng</a> <a href="https://t.co/daW3ItywQb">https://t.co/daW3ItywQb</a></p>&mdash; Provinsi Jawa Tengah #JatengGayeng (@provjateng) <a href="https://twitter.com/provjateng/status/1176316890483847168?ref_src=twsrc%5Etfw">September 24, 2019</a></blockquote>
      </div>
    </section>
  )
}